export const speakerInit = () => {
    const speakerList = document.querySelector('.speaker__list');

    if (speakerList) {
        // Clear existing content
        // speakerList.innerHTML = '';

        // Border colors
        const colors = [
            '#FE8B73', '#72EC5D', '#86C49F', '#CFB5FF', '#88C2D0',
            '#FF8AEF', '#FFDB5C', '#88DCBE', '#FC984D', '#99CCF9',
            '#FC9ECF', '#D0A3FF', '#ADB5FF', '#F4977F', '#FFA992',
            '#FF778', '#DA9DE9', '#FFC6C6', '#A8C272', '#A7C2FF',
            '#C5FF4E', '#F783C8', '#FFB49F', '#E5CD62', '#A3FF9E',
            '#A8C28C', '#8DD2FF', '#FFAB67', '#E7AF6D', '#6CDA7E',
            '#FFB856', '#F599B7', '#A8BCE0', '#FCB3FF'
        ];

        // Fisher-Yates shuffle for Colors
        for (let i = colors.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [colors[i], colors[j]] = [colors[j], colors[i]];
        }

        const renderFromData = (data) => {
            const catalysts = data.catalyst;
            if (!catalysts || !Array.isArray(catalysts)) return;

            // Fisher-Yates shuffle for Speakers
            for (let i = catalysts.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [catalysts[i], catalysts[j]] = [catalysts[j], catalysts[i]];
            }

            const mql = window.matchMedia('(max-width: 768px)');
            const getInitialLimit = () => mql.matches ? 14 : 15;
            let isExpanded = false;

            const renderList = (limit) => {
                speakerList.innerHTML = '';
                const fragment = document.createDocumentFragment();
                const itemsToShow = catalysts.slice(0, limit);

                itemsToShow.forEach((item, index) => {
                    const color = colors[index % colors.length];
                    const li = document.createElement('li');
                    li.classList.add('speaker__item');
                    const linkUrl = `https://uoc.world/people/details/?id=${item.id}`;
                    li.innerHTML = `
                        <a href="${linkUrl}" target="_blank" rel="noopener noreferrer" style="text-decoration: none; color: inherit; display: flex; flex-direction: column; align-items: center; width: 100%;">
                            <figure class="speaker__fig" style="border-color: ${color};">
                                <img src="${item.image_url}" alt="${item.name}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">
                            </figure>
                            <div class="speaker__description" style="text-align: center;">
                                <div class="speaker__descTitle">${item.name}</div>
                                <div class="speaker__subtitle">${item.position || ''}</div>
                            </div>
                        </a>
                    `;
                    fragment.appendChild(li);
                });
                speakerList.appendChild(fragment);
            };

            const updateButton = () => {
                const currentInitialLimit = getInitialLimit();
                const shouldShowButton = catalysts.length > currentInitialLimit;

                let buttonContainer = document.querySelector('.speaker__more-container');

                if (!shouldShowButton) {
                    if (buttonContainer) buttonContainer.remove();
                    return;
                }

                let button;
                if (!buttonContainer) {
                    buttonContainer = document.createElement('div');
                    buttonContainer.classList.add('speaker__more-container');
                    button = document.createElement('button');
                    button.classList.add('speaker__more-btn');
                    button.style.background = 'transparent';
                    button.style.border = 'none';
                    button.style.padding = '0';
                    button.addEventListener('click', () => {
                        isExpanded = !isExpanded;
                        refresh();
                        if (!isExpanded) {
                            setTimeout(() => {
                                const buttonRect = button.getBoundingClientRect();
                                const absoluteTop = buttonRect.top + window.pageYOffset;
                                const targetScroll = absoluteTop - (window.innerHeight * 0.8);

                                window.scrollTo({
                                    top: Math.max(0, targetScroll),
                                    behavior: 'smooth'
                                });
                            }, 50);
                        }
                    });
                    buttonContainer.appendChild(button);
                    speakerList.parentNode.insertBefore(buttonContainer, speakerList.nextSibling);
                } else {
                    button = buttonContainer.querySelector('.speaker__more-btn');
                }

                if (isExpanded) {
                    button.innerHTML = '<img src="./assets/images/text/close.png" alt="Close">';
                    button.classList.add('is-expanded');
                } else {
                    button.innerHTML = '<img src="./assets/images/text/view-more.png" alt="View More">';
                    button.classList.remove('is-expanded');
                }
            };

            const refresh = () => {
                const limit = isExpanded ? catalysts.length : getInitialLimit();
                renderList(limit);
                updateButton();
            };

            refresh();

            mql.addEventListener('change', () => {
                refresh();
            });

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        speakerList.classList.add('is-active');
                        observer.unobserve(speakerList);
                    }
                });
            }, {
                threshold: 0.1
            });
            observer.observe(speakerList);

            // Randomize border colors every 3 seconds
            setInterval(() => {
                const figures = speakerList.querySelectorAll('.speaker__fig');
                figures.forEach(fig => {
                    const randomColor = colors[Math.floor(Math.random() * colors.length)];
                    fig.style.borderColor = randomColor;
                });
            }, 3000);
        };

        // Skeleton Render
        const renderSkeleton = () => {
            speakerList.innerHTML = '';
            const fragment = document.createDocumentFragment();
            const limit = window.matchMedia('(max-width: 768px)').matches ? 14 : 15;

            for (let i = 0; i < limit; i++) {
                const li = document.createElement('li');
                li.classList.add('speaker__item', 'skeleton');
                li.innerHTML = `
                    <div class="skeleton__fig"></div>
                    <div class="speaker__description" style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                        <div class="skeleton__text"></div>
                        <div class="skeleton__text"></div>
                    </div>
                `;
                fragment.appendChild(li);
            }
            speakerList.appendChild(fragment);
        };

        // Fetch Data with Fallback
        const fetchData = async () => {
            // renderSkeleton(); // Show skeleton before fetch

            // CHANGE THIS TO false WHEN CORS ISSUE IS RESOLVED
            const USE_LOCAL_DATA = false;

            if (USE_LOCAL_DATA) {
                try {
                    // Simulate network delay to show skeleton (Optional, for demo)
                    // await new Promise(resolve => setTimeout(resolve, 1000));

                    console.log('Using local speakers.json data...');
                    const response = await fetch('./speakers.json');
                    if (!response.ok) throw new Error('Local speakers.json not found');
                    const data = await response.json();
                    renderFromData(data);
                } catch (error) {
                    console.error('Local fetch failed:', error);
                }
                return;
            }

            try {
                const response = await fetch('https://api.uoc.world/v1/mandala?id=nsDwI6MqO2S');
                if (!response.ok) throw new Error('API response not ok');
                const data = await response.json();
                renderFromData(data);
            } catch (error) {
                console.warn('API fetch failed, falling back to local speakers.json:', error);
                try {
                    const fallbackResponse = await fetch('./speakers.json');
                    if (!fallbackResponse.ok) throw new Error('Local speakers.json not found');
                    const fallbackData = await fallbackResponse.json();
                    renderFromData(fallbackData);
                } catch (fallbackError) {
                    console.error('Both API and local fetch failed:', fallbackError);
                }
            }
        };

        fetchData();
    }
};
